exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addEventModal .v-messages__message{line-height:unset}#addEventModal .modal__content{margin-top:15px}#addEventModal .v--modal-box.v--modal{min-height:250px!important;min-width:400px!important;max-width:400px!important;max-height:250px!important}#addEventModal .modal__footer{padding-bottom:10px}#addEventModal .v-label.theme--light.error--text{font-size:12px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ac388e4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/AddEvent.vue
// module id = 1382
// module chunks = 0